(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/store.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/store.js');

'use strict';

const svsconfig = svs.core.config.data.svsconfig;
const _RTK = RTK,
  configureStore = _RTK.configureStore,
  combineReducers = _RTK.combineReducers;
const _svs$gamePackage$redu = svs.gamePackage.redux,
  accountSlice = _svs$gamePackage$redu.accountSlice,
  numbergamesSlice = _svs$gamePackage$redu.numbergamesSlice,
  ticketsSlice = _svs$gamePackage$redu.ticketsSlice,
  gamePackageSlice = _svs$gamePackage$redu.gamePackageSlice;
const _svs$gamePackage$redu2 = svs.gamePackage.redux.middlewares,
  loadGamesFromLocalStorage = _svs$gamePackage$redu2.loadGamesFromLocalStorage,
  saveGamesToLocalStorage = _svs$gamePackage$redu2.saveGamesToLocalStorage,
  persistGamesMiddleware = _svs$gamePackage$redu2.persistGamesMiddleware;
const reducer = combineReducers({
  account: accountSlice.reducer,
  numbergames: numbergamesSlice.reducer,
  tickets: ticketsSlice.reducer,
  gamePackage: gamePackageSlice.reducer
});
const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(persistGamesMiddleware),
  preloadedState: (() => {
    const numbergamesInitialState = numbergamesSlice.getInitialState();
    const gamesPackageInitialState = gamePackageSlice.getInitialState();
    const foundPersistedGames = loadGamesFromLocalStorage({
      index: gamesPackageInitialState.activeIndex
    });
    const preloadedState = {
      numbergames: _.clone(numbergamesInitialState)
    };
    if (foundPersistedGames) {
      preloadedState.numbergames.games = foundPersistedGames;
    } else {
      saveGamesToLocalStorage({
        index: gamesPackageInitialState.activeIndex,
        games: numbergamesInitialState.games
      });
    }
    return preloadedState;
  })(),
  devTools: svsconfig.env !== 'production'
});
svs.gamePackage.redux.store = store;

 })(window);